import * as React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {toastr} from 'react-redux-toastr'
import axios from 'axios'


import './../styles/auth/auth.css'
import './../styles/auth/createUser.css'
import logo from './../images/logo.png'
import {Button, TYPES} from './../components/shared/button'
import Page from './../components/shared/page'


class CreateUser extends React.Component {
  constructor() {
    super()

    this.state={
      email: '',
      location: '',
      disabled: false
    }
  }

  onSubmit = (event) => {
    event.preventDefault()
    this.setState({disabled: true})
    let payload = {
      email: this.state.email,
      location: this.state.location
    }
    const { token } = this.props.auth
    axios.post(
      '/api/create_user/',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${token}`
        }
      }
    ).then(response => {
      this.toast()
    }).catch(error => {
        toastr.error('Error', error.response.data.error)
        }
      )
  }

  toast = () => {
    toastr.removeByType('error')
    toastr.success('Success', 'User Created')
    this.props.history.push(`/admin/locations`)
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  render () {
    const { locations } = this.props.auth.user
    return (
      <Page history={this.props.history}>
        <div className='create-user-container'>
          <div className='auth-box'>
          <img src={logo} alt='BayWatch Technologies' />
            <form onSubmit={this.onSubmit}>
              <input type='email' placeholder='Email' name='email' onChange={this.handleChange} className='auth-input'/>
              <select className='create-user-location'  name='location' defaultValue={this.props.visits.params.locationId} onChange={this.handleChange}>
                <option value=''> Location </option>
                {locations.map((location, index)=> {
                  return(
                    <option value={location.id} key={"location" + location.id}>{location.name}</option>
                  )
                 })
                }
              </select>
              <div className='auth-button-container'>
                <Button
                  text='Create User'
                  type='logIn'
                  buttonType={TYPES.SUBMIT}
                  disabled={this.state.disabled}
                />
              </div>
            </form>
            <div className='auth-password-reset'>
              <Link to={'/admin/locations'}>
                <p>Cancel</p>
              </Link>
            </div>
          </div>
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(CreateUser);



// WEBPACK FOOTER //
// ./src/pages/createUser.js